import React from 'react'
import ATHeaderText from '../../../common/headerText/ATHeaderText'
import ATIconButton from '../../../common/formComponent/ATIconButton'
import { MdClose } from 'react-icons/md'
import ATStepper from '../../../common/appStepper/ATStepper'
import AddRole from './AddRole'
import SelectCapabilities from './SelectCapabilities'
import { useTranslation } from 'react-i18next'
import { AddRolePopupProps } from '../../../../utils/types/roles/RolesTypes'
import { useAddRolePopup } from '../../../../customHooks/usermanagement/useRolePopup'

const AddRolePopup = ({ onCloseModal, isMaster }: AddRolePopupProps) => {
  const { t } = useTranslation(['translation'])
  const {
    activeStep,
    steps,
    appRolesData,
    roleDetails,
    continueButtonHandler,
    backButtonHandler,
    handleCloseModel,
    addEditRoleHandler,
  } = useAddRolePopup({ onCloseModal, isMaster })

  const getComponentConditionally = (): React.ReactNode => {
    switch (activeStep) {
      case 0:
        return (
          <AddRole
            appRolesData={appRolesData ?? []}
            continueButtonHandler={continueButtonHandler}
            onCloseModal={handleCloseModel}
            roleDetails={roleDetails}
          />
        )
      case 1:
        return (
          <SelectCapabilities
            backButtonHandler={backButtonHandler}
            onCloseModal={handleCloseModel}
            onSaveHandler={addEditRoleHandler}
          />
        )
      default:
        return null
    }
  }
  return (
    <div className="add-hauler-modal-content">
      <ATHeaderText
        title={
          roleDetails?.isEdit
            ? t('user_management.edit_role')
            : t('user_management.add_role')
        }
      >
        <ATIconButton
          icon={<MdClose size={16} className="text-dark" />}
          onClick={handleCloseModel}
          variant="link"
        />
      </ATHeaderText>
      <div className="px-4 py-2">
        <ATStepper steps={steps} activeStep={activeStep} />
      </div>
      <div>{getComponentConditionally()}</div>
    </div>
  )
}

export default AddRolePopup
